
import { defineComponent } from "vue";
import { RouterLink, useRoute } from "vue-router";

import { site } from "../data/site";
import style from "./style.module.less";

// 模块子导航条：品牌 + 模块菜单 + 「我是谜首页」入口 + 免费发布按钮
export default defineComponent({
  name: "XiyouSubNav",
  setup() {
    const route = useRoute();
    return () => (
      <div class={style.nav}>
        <div class={style.navInner}>
          <RouterLink class={style.brand} to={{ name: "XiyouHome" }}>
            <span class={style.brandMark}>信</span>
            <span class={style.brandText}>
              <span class={style.brandName}>{site.name}</span>
              <span class={style.brandSlogan}>{site.slogan}</span>
            </span>
          </RouterLink>
          <div class={style.menus}>
            {site.menus.map((menu) => (
              <RouterLink
                key={menu.name}
                class={[
                  style.menuItem,
                  menu.name === route.name ? style.menuActive : null,
                ]}
                to={{ name: menu.name }}
              >
                {menu.text}
              </RouterLink>
            ))}
            <span class={style.divider} />
            <RouterLink class={style.menuItem} to={{ name: "Home" }}>
              我是谜首页
            </RouterLink>
          </div>
          <RouterLink class={style.publishBtn} to={{ name: "XiyouPublish" }}>
            免费发布
          </RouterLink>
        </div>
      </div>
    );
  },
});
